
import React, { useState, useEffect } from 'react';
import { 
  BrowserRouter as Router, Routes, Route 
} from 'react-router-dom';

import './App.css';

import api from "./components/services/api";
import { logout } from "./components/services/auth";


import LandingPage from './components/LandingPage'
import LandingPageCopy from './components/LandingPageCopy';

import ProjectGallery from './components/project/ProjectGallery'
import PrephysicianGallery from './components/prephysician/PrephysicianGallery'

import ProjectCardDetailed from './components/project/ProjectCardDetailed'
import PrephysicianCardDetailed from './components/prephysician/PrephysicianCardDetailed'

import ProjectNew from './components/project/ProjectNew'
import PrephysicianNew from './components/prephysician/PrephysicianNew'

import ProjectEdit from './components/project/ProjectEdit'
import PrephysicianEdit from './components/prephysician/PrephysicianEdit'

import PrephysicianRegister from './components/prephysician/PrephysicianRegister'

import Signup from './components/Signup'
import Login from './components/Login'

import Home from './components/Home'

import NavbarNew from './components/NavbarNew'


export default function App () {

  const[userData, setUserData]=useState('')

  const[prephysicianUserData, setPrephysicianUserData]=useState('')
  const[prephysicianData, setPrephysicianData]=useState('')
  const[prephysicianModal, setPrephysicianModal]=useState('')
  
  const[projectUserData, setProjectUserData]=useState('')
  const[projectData, setProjectData]=useState('')
  const[projectModal, setProjectModal]=useState('')

  const[messageData, setMessageData]=useState('')
  const[ratingData, setRatingData]=useState('')
 


  //Get user with parameters from database
  const getUser = async() => {

    try {
      const response = await api.get("/user");

      setUserData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getUser();
    }, []);
  
  

  //Get Prephysician with parameters from database
  const getPrephysicianUser = async() => {

    try {
      const response = await api.get("/prephysicianuser");

      setPrephysicianUserData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getPrephysicianUser();
    }, []);
 
 
    //Get Prephysician with parameters from database
  const getPrephysician = async() => {

    try {
      const response = await api.get("/prephysician");

      setPrephysicianData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getPrephysician();
    }, []);
  
  
  //Get users projects with parameters from database
  const getProjectUser = async() => {

    try {
      const response = await api.get("/projectuser");

      setProjectUserData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getProjectUser();
    }, []);
 

    //Get all projects with parameters from database
  const getProject = async() => {

    try {
      const response = await api.get("/project");

      setProjectData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getProject();
    }, []);


  //Get all message with parameters from database
  const getMessage = async() => {

    try {
      const response = await api.get("/message");

      setMessageData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getMessage();
    }, []);


    //Get all rating with parameters from database
  const getRating = async() => {

    try {
      const response = await api.get("/rating");

      setRatingData(response.data.rows)

    } catch (err) {
      console.error(err.message)
    }
  }

  useEffect(() => {
      getRating();
    }, []);





  return (
      <Router>
        {/* <NavbarNew
          userData={userData}
        /> */}
        <Routes>
          <Route 
            path="/projectnew"
            element={
              <ProjectNew
                projectUserData={projectUserData}
                messageData={messageData}
                ratingData={ratingData}
              />
            }
          />  

          <Route 
            path="/projectedit"
            element={
              <ProjectEdit
                projectUserData={projectUserData}
                projectModal={projectModal}
                setProjectModal={setProjectModal}
                messageData={messageData}
                ratingData={ratingData}
              />
            }
          />  

          <Route 
            path="/projectdetails"
            element={
              <ProjectCardDetailed
                projectData={projectData}
                projectUserData={projectUserData}
                projectModal={projectModal}
                setProjectModal={setProjectModal}
                messageData={messageData}
                ratingData={ratingData}
                userType={
                  userData
                  ? userData[0].user_type
                  : ''
                }
                userEmail={
                  userData
                  ? userData[0].email
                  : ''
                }
              />
            }
          />  
          <Route 
            path="/projects"
            element={
              <ProjectGallery
                userData={userData}
                projectData={projectData}
                prephysicianData={prephysicianData}
                messageData={messageData}
                ratingData={ratingData}
                projectModal={projectModal}
                setProjectModal={setProjectModal}
              />
            }
          />
          <Route 
            path="/prephysician"
            element={
              <PrephysicianGallery
                userData={userData}
                projectData={projectData}
                prephysicianData={prephysicianData}
                messageData={messageData}
                ratingData={ratingData}
                prephysicianModal={prephysicianModal}
                setPrephysicianModal={setPrephysicianModal}
              />
            }
          />
          <Route 
            path="/prephysiciandetails"
            element={
              <PrephysicianCardDetailed
                prephysicianData={prephysicianData}
                prephysicianUserData={prephysicianUserData}
                prephysicianModal={prephysicianModal}
                setPrephysicianModal={setPrephysicianModal}
                messageData={messageData}
                ratingData={ratingData}
                userType={
                  userData
                  ? userData[0].user_type
                  : ''
                }
                userEmail={
                  userData
                  ? userData[0].email
                  : ''
                }
              />
            }
          />
          <Route 
            path="/prephysicianregister"
            element={
              <PrephysicianRegister
  
              />
            }
          />
          <Route 
            path="/prephysiciannew"
            element={
              <PrephysicianNew
                prephysicianUserData={prephysicianUserData}
                messageData={messageData}
                ratingData={ratingData}
              />
            }
          />
          <Route 
            path="/prephysicianedit"
            element={
              <PrephysicianEdit
                prephysicianUserData={prephysicianUserData}
                prephysicianModal={prephysicianModal}
                setPrephysicianModal={setPrephysicianModal}
                messageData={messageData}
                ratingData={ratingData}
              />
            }
          />
          <Route 
            path="/signup"
            element={
              <Signup
  
              />
            }
          /> 
          <Route 
            path="/login"
            element={
              <Login
            
              />
            }
          />
          <Route 
            path="/home"
            element={
              <Home
                userData={userData}
                projectData={projectData}
                projectUserData={projectUserData}
                projectModal={projectModal}
                setProjectModal={setProjectModal}
                prephysicianData={prephysicianData}
                prephysicianUserData={prephysicianUserData}
                prephysicianModal={prephysicianModal}
                setPrephysicianModal={setPrephysicianModal}
                messageData={messageData}
                ratingData={ratingData}
              />
            }
          />
          <Route 
            path="/"
            element={
              <LandingPageCopy/>
              // <LandingPage
            
              // />
            }
          />
        </Routes>
      </Router>
  );
}